import { DlqTabContainer } from '../../dlqTab/DlqTabContainer';

/** Route element for Dead letter (/main/dod/dlq). */
export const DlqRoute = (): JSX.Element => <DlqTabContainer />;
